import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect, type ReactElement } from 'react';

import { BootSplash } from '~/app/boot-splash';
import { NotFound } from '~/app/not-found';
import { useRecentStore } from '~/stores/recent-store';

import { useActiveTenant } from '@/hooks/use-active-tenant';
import { useRecords } from '@/hooks/use-records';

/**
 * Every page of one record. The record's areas are the tabs under each area
 * page's head (`features/record/record-tabs.tsx`); this layout notes the record
 * as opened and answers a record that is not there.
 */
function RecordLayout(): ReactElement {
  const { recordId } = Route.useParams();
  const { tenantId } = useActiveTenant();
  const { state } = useRecords(tenantId);
  const noteOpened = useRecentStore((store) => store.noteOpened);

  useEffect(() => {
    if (tenantId !== null) noteOpened(tenantId, recordId);
  }, [tenantId, recordId, noteOpened]);

  if (state.status === 'loading') return <BootSplash />;
  const records = state.status === 'ready' ? state.list.records : [];
  if (!records.some((one) => one.id === recordId)) return <NotFound />;

  return <Outlet />;
}

export const Route = createFileRoute('/_app/records/$recordId')({ component: RecordLayout });
